<input type="checkbox" #marketLoss kendoCheckBox [checked]="checked" (keydown.enter)="onEnter()"
  (change)="onChange($event?.target)" />

<kendo-label class="k-checkbox-filter-label ml-12 mr-24" [for]="marketLoss" text="Market Loss"></kendo-label>
